import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPageListingManual = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 30.041 36.382",
	fill: "currentColor",
	stroke: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Sideutlisting_Manuell",
		transform: "translate(-1408.811 -1020.469)",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Group_3103",
			"data-name": "Group 3103",
			transform: "translate(-1 314.26)",
			children: [/* @__PURE__ */ _jsx("path", {
				id: "library_books_FILL0_wght300_GRAD0_opsz48",
				d: "M120.085,213.207H134.45v-1.842H120.085Zm0-3.982H134.45v-1.842H120.085Zm-3.245,10.661a2.368,2.368,0,0,1-2.342-2.342v-27.2A2.368,2.368,0,0,1,116.841,188H137.7a2.368,2.368,0,0,1,2.342,2.342v27.2a2.368,2.368,0,0,1-2.342,2.342Zm0-1.842H137.7a.537.537,0,0,0,.5-.5v-27.2a.537.537,0,0,0-.5-.5h-20.86a.537.537,0,0,0-.5.5v27.2a.537.537,0,0,0,.5.5Zm-4.5,6.339A2.368,2.368,0,0,1,110,222.041v-22.7h1.842v22.7a.537.537,0,0,0,.5.5h22.7v1.842Zm4-34.54v0Z",
				transform: "translate(1299.809 518.209)"
			}), /* @__PURE__ */ _jsx("path", {
				id: "image_FILL0_wght300_GRAD0_opsz48",
				d: "M147.232,262.18h14.26l-4.3-5.725-4.01,5.112L150.45,258l-3.218,4.176Z",
				transform: "translate(1272.814 457.233)"
			})]
		})
	})
});
export default SvgPageListingManual;
